import { useMemo } from "react";

import {
  filterDeliverablesByAllowedChannels,
  getDeliverablesFromTemplateData,
  getTemplateSummary,
  getTemplateWriterValidationError,
} from "components/modals/create-campaign-with-writer-modal/create-campaign-with-writer-modal.helper";

import { useAllowedCreativeChannels } from "hooks/api/use-allowed-creative-channels";
import { useCampaignTemplate } from "hooks/api/use-campaign-templates";

export const useSelectedCampaignTemplate = (
  campaignTemplateId: string,
  programStrategy: string | undefined,
) => {
  const { data: campaignTemplate, isLoading } = useCampaignTemplate(campaignTemplateId, {
    enabled: Boolean(campaignTemplateId),
  });
  const { allowedChannels, isLoadingAllowedChannels } = useAllowedCreativeChannels(programStrategy);

  const deliverables = useMemo(() => {
    if (!campaignTemplateId || isLoadingAllowedChannels) {
      return [];
    }

    return filterDeliverablesByAllowedChannels(
      getDeliverablesFromTemplateData(campaignTemplate?.data),
      allowedChannels,
    );
  }, [campaignTemplate?.data, campaignTemplateId, allowedChannels, isLoadingAllowedChannels]);

  const templateSummary = useMemo(
    () => getTemplateSummary(campaignTemplate?.data),
    [campaignTemplate?.data],
  );

  const templateValidationError = getTemplateWriterValidationError(campaignTemplate?.data);

  return {
    deliverables,
    isLoadingDeliverables: isLoading || isLoadingAllowedChannels,
    templateSummary,
    templateValidationError,
  };
};
